var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTonBlueCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4021 8.66602H10.5969C8.61022 8.66602 7.35101 10.8091 8.35051 12.5415L15.0191 24.1C15.4542 24.8547 16.5448 24.8547 16.9799 24.1L23.6498 12.5415C24.648 10.8118 23.3888 8.66602 21.4034 8.66602H21.4021ZM15.0136 20.6338L13.5613 17.823L10.0571 11.5556C9.82592 11.1545 10.1114 10.6404 10.5955 10.6404H15.0123V20.6351L15.0136 20.6338ZM21.9392 11.5543L18.4363 17.8244L16.984 20.6338V10.6391H21.4007C21.8848 10.6391 22.1703 11.1531 21.9392 11.5543Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonBlueCoin);
export default __webpack_public_path__ + "static/media/ton_blue_coin.0c8731809a3bc7a03d8453e15e73bd0d.svg";
export { ForwardRef as ReactComponent };